import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CompanyService } from '@company/company.service';
import { ICompany, Company } from '@company/company.structures';

import { ROLES } from '@utils';
import { IUser } from '@base/interfaces';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-company-detail',
  templateUrl: './company-detail.component.html',
  styleUrls: ['./company-detail.component.sass']
})

export class CompanyDetailComponent implements OnInit, OnChanges {
  private subscriptions: Subscription[];
  @Input() company: Partial<ICompany>;
  analysts = [];
  customers = [];
  modules = [];

  constructor(
    private sidenav: CompanyService,
  ) {
    this.company = new Company();
    this.subscriptions = [];
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.analysts = [];
    this.customers = [];
    this.modules = [];

    if (typeof this.company.users !== 'undefined') {
      this.clearSubscriptions();
      this.company['id'] = this.company.hasOwnProperty('pk') ? this.company['pk'] : this.company.id;
      this.getCompanyDetails(this.company['id']);
    }
  }

  private clearSubscriptions() {
    this.subscriptions.map(s => s.unsubscribe());
  }

  private getCompanyDetails(companyId) {
    this.sidenav.getCompany(companyId)
    .pipe((take(1)))
    .subscribe(((company: ICompany) => {
      this.company = company;
      this.company.users.map((item: object) => {
        const user: IUser = (item.hasOwnProperty('user')) ? item['user'] : item;
        const userRole = user.role['code'];
        const row = (this.company.hasOwnProperty('pk')) ? item : user;

        if (user.role['code'] === ROLES.ANALYST) {
          this.analysts = [...this.analysts, row];
        } else if (userRole === ROLES.CUSTOMER) {
          this.customers = [...this.customers, row];
        }

        return null;
      });

      this.company.modules.map((item) => {
        const row = (item.hasOwnProperty('module')) ? item['module'] : item;
        const active = item['active'];
        this.modules = [...this.modules, row];
      });
    }));
  }

  toggleRightSidenav() {
    this.sidenav.toggleSidenav();
  }
}
